export default function Access() {
  return (
    <section id="access" className="py-24 bg-[#f5f5f5]">
      <div className="px-6 lg:px-20 max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a1a3e]"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            アクセス。
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 items-start">
          {/* Text */}
          <div className="w-full lg:w-[420px] flex-shrink-0 space-y-7">
            <div>
              <p className="text-[#47d6d4] font-bold text-base mb-1">Golph.club Suminoe</p>
              <p className="text-[#1a1a3e]/65 text-sm leading-relaxed">
                大阪市住之江区中加賀屋２丁目８−１ 2F
              </p>
            </div>

            <div className="space-y-4">
              {[
                {
                  icon: 'ri-train-line',
                  label: '電車',
                  detail: '大阪メトロ四つ橋線「北加賀屋駅」1番出口 徒歩6分',
                },
                {
                  icon: 'ri-car-line',
                  label: 'お車',
                  detail: '阪神高速堺線 玉出出口 車5分',
                },
                {
                  icon: 'ri-parking-box-line',
                  label: '駐車場',
                  detail: '無料駐車場3台（縦列・奥から利用）',
                },
                {
                  icon: 'ri-time-line',
                  label: '営業時間',
                  detail: '6:00〜23:55（年中無休）',
                },
              ].map((item) => (
                <div key={item.label} className="flex items-start gap-4">
                  <div className="w-9 h-9 rounded-full bg-[#47d6d4]/10 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-[#47d6d4] text-sm`}></i>
                  </div>
                  <div>
                    <p className="text-[#1a1a3e] text-sm font-semibold">{item.label}</p>
                    <p className="text-[#1a1a3e]/55 text-xs mt-0.5 leading-relaxed">{item.detail}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-white rounded-xl p-5 border border-[#1a1a3e]/6">
              <p className="text-[#1a1a3e]/50 text-xs font-bold mb-2 flex items-center gap-1.5">
                <i className="ri-map-pin-line text-[#e85d2c]"></i>道順
              </p>
              <p className="text-[#1a1a3e]/45 text-xs leading-relaxed">
                幻たこ隣の個別対応指導の螢雪パーソナル住之江教室2階。裏口BOSS自販機横の路地を進み2階へ。
              </p>
            </div>
          </div>

          {/* Map */}
          <div className="flex-1 min-h-[380px] lg:min-h-[440px] rounded-2xl overflow-hidden border border-[#1a1a3e]/8">
            <iframe
              title="Golph.club Suminoe アクセスマップ"
              src="https://maps.google.com/maps?q=34.6176105,135.4805549&z=17&hl=ja&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '380px' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

        {/* ── Parking Section ── */}
        <div className="mt-16">
          <h3
            className="text-2xl sm:text-3xl font-bold text-[#1a1a3e] mb-4 text-center"
            style={{ fontFamily: "'Noto Serif JP', serif", textWrap: 'balance', wordBreak: 'auto-phrase' } as React.CSSProperties}
          >
            駐車場について
          </h3>

          {/* Parking summary note */}
          <div className="max-w-2xl mx-auto mb-10 bg-white rounded-xl border border-[#1a1a3e]/8 px-6 py-5">
            <p
              className="text-[#1a1a3e]/65 text-[14px] leading-[1.9] text-center"
              style={{ wordBreak: 'auto-phrase' } as React.CSSProperties}
            >
              一度に3台駐車可能な無料駐車場を店舗より15m先にご用意しております。<br className="hidden sm:block" />
              縦列で３台止められるスペースになりますので、次の予約のお客様のご迷惑にならないようにご利用ください。
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Parking 1 */}
            <div className="bg-white rounded-2xl overflow-hidden border border-[#1a1a3e]/8">
              <div className="w-full">
                <img
                  src="https://static.readdy.ai/image/faab8405af96b700637a376baf26c6c6/4e969561e7a7ffa8b8c9d71022ffcde1.jpeg"
                  alt="Golph.club Suminoe 駐車場 縦列利用"
                  className="w-full h-auto block"
                />
              </div>
              <div className="px-6 py-5">
                <p
                  className="text-[#1a1a3e]/65 text-[14px] leading-[1.85]"
                  style={{ wordBreak: 'auto-phrase' } as React.CSSProperties}
                >
                  必ず奥からご利用ください。また構造上、後からのお客様がご利用になられる前に、速やかに出庫してください。また駐車の際、前に利用のお客様が出られるまで車庫内でお待ちください。
                </p>
              </div>
            </div>

            {/* Parking 2 */}
            <div className="bg-white rounded-2xl overflow-hidden border border-[#1a1a3e]/8">
              <div className="w-full">
                <img
                  src="https://static.readdy.ai/image/faab8405af96b700637a376baf26c6c6/d4f312f57d891419e18b9e03b26c6a0a.jpeg"
                  alt="Golph.club Suminoe 駐車場から店舗までのルート"
                  className="w-full h-auto block"
                />
              </div>
              <div className="px-6 py-5">
                <p
                  className="text-[#1a1a3e]/65 text-[14px] leading-[1.85]"
                  style={{ wordBreak: 'auto-phrase' } as React.CSSProperties}
                >
                  駐車場から店舗までは商店街のアーケードを挟んで15mほどの距離になります。迷惑駐車など、周りの住民のご迷惑にならないようにご利用ください。
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
